module.exports = __webpack_public_path__ + "img/ad-start_logo_white.67cedaa5.png";